import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.isActive}}
  {{! template-lint-disable no-invalid-interactive no-pointer-down-event-binding }}
  <div
    {{on "keydown" (action "keydown")}}
    class="emoji-picker {{if this.isActive 'opened'}}"
  >
    {{! template-lint-enable no-invalid-interactive no-pointer-down-event-binding }}
    <div class="emoji-picker-category-buttons">
      {{#if this.recentEmojis.length}}
        <button
          {{on "click" (fn this.onCategorySelection "recent")}}
          data-section="recent"
          type="button"
          class="btn btn-flat category-button emoji"
        >
          {{replace-emoji ":star:"}}
        </button>
      {{/if}}

      <EmojiGroupButtons
        @onCategorySelection={{this.onCategorySelection}}
        @tagName=""
      />

      {{#each-in this.customEmojis as |group emojis|}}
        <button
          {{on "click" (fn this.onCategorySelection (concat "custom-" group))}}
          data-section={{concat "custom-" group}}
          type="button"
          class="btn btn-default category-button emoji"
        >
          {{replace-emoji (concat ":" (get emojis "0.code") ":")}}
        </button>
      {{/each-in}}
    </div>

    <div class="emoji-picker-content">
      <div class="emoji-picker-search-container">
        <Input
          class="filter"
          name="filter"
          @value={{@initialFilter}}
          placeholder={{i18n "emoji_picker.filter_placeholder"}}
          autocomplete="off"
          @type="search"
          autocorrect="off"
          autocapitalize="off"
          {{on "input" (action "onFilterChange")}}
        />

        {{d-icon "search"}}
      </div>

      <div
        class="emoji-picker-emoji-area"
        role="button"
        {{on "click" this.onEmojiSelection}}
        {{on "mouseover" this.onEmojiHover}}
      >
        <div class="results"></div>

        <div class="emojis-container">
          {{#if this.recentEmojis.length}}
            <div class="section recent" data-section="recent">
              <div class="section-header">
                <span class="title">{{i18n "emoji_picker.recent"}}</span>
                <DButton
                  @icon="trash-alt"
                  @action={{this.onClearRecent}}
                  class="trash-recent"
                />
              </div>
              <div class="section-group">
                {{#each this.recentEmojis as |emoji|}}
                  {{replace-emoji
                    (concat ":" emoji ":")
                    (hash lazy=true tabIndex="0" class="recent-emoji")
                  }}
                {{/each}}
              </div>
            </div>
          {{/if}}

          <EmojiGroupSections />

          {{#each-in this.customEmojis as |group emojis|}}
            <div class="section" data-section="custom-{{group}}">
              <div class="section-header">
                <span class="title">
                  {{i18n
                    (concat "emoji_picker." group)
                    translatedFallback=group
                  }}
                </span>
              </div>
              {{#if emojis.length}}
                <div class="section-group">
                  {{#each emojis as |emoji|}}
                    <span>
                      <img
                        title={{emoji.code}}
                        width="20"
                        height="20"
                        loading="lazy"
                        class="emoji"
                        src={{emoji.src}}
                      />
                    </span>
                  {{/each}}
                </div>
              {{/if}}
            </div>
          {{/each-in}}
        </div>
      </div>

      <div class="emoji-picker-footer">
        <div class="emoji-picker-emoji-info">
          {{#if this.hoveredEmoji}}
            {{replace-emoji (concat ":" this.hoveredEmoji ":")}}
          {{/if}}
        </div>

        <div class="emoji-picker-diversity-picker">
          {{#each this.diversityScales as |diversityScale index|}}
            <DButton
              @icon={{diversityScale.icon}}
              @title={{diversityScale.title}}
              @action={{fn this.onDiversitySelection index}}
              class={{concat-class "diversity-scale" diversityScale.name}}
            />
          {{/each}}
        </div>
      </div>
    </div>
  </div>

  {{#if this.site.mobileView}}
    <div
      role="button"
      class="emoji-picker-modal-overlay"
      {{on "click" this.onClose}}
    ></div>
  {{/if}}
{{/if}}
*/
{
  "id": "8Pi6nSa+",
  "block": "[[[41,[30,0,[\"isActive\"]],[[[1,\"  \"],[11,0],[16,0,[29,[\"emoji-picker \",[52,[30,0,[\"isActive\"]],\"opened\"]]]],[4,[38,1],[\"keydown\",[28,[37,2],[[30,0],\"keydown\"],null]],null],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"emoji-picker-category-buttons\"],[12],[1,\"\\n\"],[41,[30,0,[\"recentEmojis\",\"length\"]],[[[1,\"        \"],[11,\"button\"],[24,\"data-section\",\"recent\"],[24,0,\"btn btn-flat category-button emoji\"],[24,4,\"button\"],[4,[38,1],[\"click\",[28,[37,3],[[30,0,[\"onCategorySelection\"]],\"recent\"],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,4],[\":star:\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[8,[39,5],null,[[\"@onCategorySelection\",\"@tagName\"],[[30,0,[\"onCategorySelection\"]],\"\"]],null],[1,\"\\n\\n\"],[42,[28,[37,7],[[30,0,[\"customEmojis\"]]],null],null,[[[1,\"        \"],[11,\"button\"],[16,\"data-section\",[28,[37,8],[\"custom-\",[30,2]],null]],[24,0,\"btn btn-default category-button emoji\"],[24,4,\"button\"],[4,[38,1],[\"click\",[28,[37,3],[[30,0,[\"onCategorySelection\"]],[28,[37,8],[\"custom-\",[30,2]],null]],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,4],[[28,[37,8],[\":\",[28,[37,9],[[30,1],\"0.code\"],null],\":\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1,2]],null],[1,\"    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"emoji-picker-content\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"emoji-picker-search-container\"],[12],[1,\"\\n        \"],[8,[39,10],[[24,0,\"filter\"],[24,3,\"filter\"],[16,\"placeholder\",[28,[37,11],[\"emoji_picker.filter_placeholder\"],null]],[24,\"autocomplete\",\"off\"],[24,\"autocorrect\",\"off\"],[24,\"autocapitalize\",\"off\"],[4,[38,1],[\"input\",[28,[37,2],[[30,0],\"onFilterChange\"],null]],null]],[[\"@value\",\"@type\"],[[30,3],\"search\"]],null],[1,\"\\n\\n        \"],[1,[28,[35,12],[\"search\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[11,0],[24,0,\"emoji-picker-emoji-area\"],[24,\"role\",\"button\"],[4,[38,1],[\"click\",[30,0,[\"onEmojiSelection\"]]],null],[4,[38,1],[\"mouseover\",[30,0,[\"onEmojiHover\"]]],null],[12],[1,\"\\n        \"],[10,0],[14,0,\"results\"],[12],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"emojis-container\"],[12],[1,\"\\n\"],[41,[30,0,[\"recentEmojis\",\"length\"]],[[[1,\"            \"],[10,0],[14,0,\"section recent\"],[14,\"data-section\",\"recent\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"section-header\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"title\"],[12],[1,[28,[35,11],[\"emoji_picker.recent\"],null]],[13],[1,\"\\n                \"],[8,[39,13],[[24,0,\"trash-recent\"]],[[\"@icon\",\"@action\"],[\"trash-alt\",[30,0,[\"onClearRecent\"]]]],null],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"section-group\"],[12],[1,\"\\n\"],[42,[28,[37,14],[[28,[37,14],[[30,0,[\"recentEmojis\"]]],null]],null],null,[[[1,\"                  \"],[1,[28,[35,4],[[28,[37,8],[\":\",[30,4],\":\"],null],[28,[37,15],null,[[\"lazy\",\"tabIndex\",\"class\"],[true,\"0\",\"recent-emoji\"]]]],null]],[1,\"\\n\"]],[4]],null],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[8,[39,16],null,null,null],[1,\"\\n\\n\"],[42,[28,[37,7],[[30,0,[\"customEmojis\"]]],null],null,[[[1,\"            \"],[10,0],[14,0,\"section\"],[15,\"data-section\",[29,[\"custom-\",[30,6]]]],[12],[1,\"\\n              \"],[10,0],[14,0,\"section-header\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"title\"],[12],[1,\"\\n                  \"],[1,[28,[35,11],[[28,[37,8],[\"emoji_picker.\",[30,6]],null]],[[\"translatedFallback\"],[[30,6]]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"],[41,[30,5,[\"length\"]],[[[1,\"                \"],[10,0],[14,0,\"section-group\"],[12],[1,\"\\n\"],[42,[28,[37,14],[[28,[37,14],[[30,5]],null]],null],null,[[[1,\"                    \"],[10,1],[12],[1,\"\\n                      \"],[10,\"img\"],[15,\"title\",[30,7,[\"code\"]]],[14,\"width\",\"20\"],[14,\"height\",\"20\"],[14,\"loading\",\"lazy\"],[14,0,\"emoji\"],[15,\"src\",[30,7,[\"src\"]]],[12],[13],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[7]],null],[1,\"                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"]],[5,6]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"emoji-picker-footer\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"emoji-picker-emoji-info\"],[12],[1,\"\\n\"],[41,[30,0,[\"hoveredEmoji\"]],[[[1,\"            \"],[1,[28,[35,4],[[28,[37,8],[\":\",[30,0,[\"hoveredEmoji\"]],\":\"],null]],null]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"emoji-picker-diversity-picker\"],[12],[1,\"\\n\"],[42,[28,[37,14],[[28,[37,14],[[30,0,[\"diversityScales\"]]],null]],null],null,[[[1,\"            \"],[8,[39,13],[[16,0,[28,[37,17],[\"diversity-scale\",[30,8,[\"name\"]]],null]]],[[\"@icon\",\"@title\",\"@action\"],[[30,8,[\"icon\"]],[30,8,[\"title\"]],[28,[37,3],[[30,0,[\"onDiversitySelection\"]],[30,9]],null]]],null],[1,\"\\n\"]],[8,9]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"    \"],[11,0],[24,\"role\",\"button\"],[24,0,\"emoji-picker-modal-overlay\"],[4,[38,1],[\"click\",[30,0,[\"onClose\"]]],null],[12],[13],[1,\"\\n\"]],[]],null]],[]],null]],[\"emojis\",\"group\",\"@initialFilter\",\"emoji\",\"emojis\",\"group\",\"emoji\",\"diversityScale\",\"index\"],false,[\"if\",\"on\",\"action\",\"fn\",\"replace-emoji\",\"emoji-group-buttons\",\"each\",\"-each-in\",\"concat\",\"get\",\"input\",\"i18n\",\"d-icon\",\"d-button\",\"-track-array\",\"hash\",\"emoji-group-sections\",\"concat-class\"]]",
  "moduleName": "discourse/components/emoji-picker.hbs",
  "isStrictMode": false
});